import React from 'react'
import logo from '../assets/logo.svg'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
// import { faCoffee } from '@fortawesome/free-solid-svg-icons'

class Footer extends React.Component{
    render(){
        return(
            <section className="bg-white py-10 md:px-10 px-2">
                <div className="grid grid-cols-12 gap-6">
                    <div className="col-span-12 md:col-span-3 bg-gray-300 rounded-lg shadow">
                        <img alt="amit painting logo" src={logo} className="w-3/4 mx-auto mt-10"/>
                    </div>
                    <div className="col-span-12 md:col-span-3 ml-10">
                       <h5 className="text-ap text-lg mb-5 font-bold">About Us</h5> 
                       <ul>
                           <Link to="/about"><li className="mt-3 hover:text-pink-600">About Us</li></Link>
                           <Link to="/projects"><li className="mt-3 hover:text-pink-600">Our Projects</li></Link>
                           <Link to="/services"><li className="mt-3 hover:text-pink-600">Our Services</li></Link>
                           <Link to="/contact-us"><li className="mt-3 hover:text-pink-600">Contact Us</li></Link>
                       </ul>
                    </div>
                    <div className="col-span-10 md:col-span-3 col-start-2">
                       <h5 className="text-ap text-lg mb-5 font-bold">Contact Us</h5> 
                       <ul>
                            <p><li className="mt-3 hover:text-pink-600">
                               <strong>Hyderabad</strong><br />
                               <p>Suchitra, Kompally, Hyderabad - 500 055</p>
                               </li>
                            </p>
                            <a href="mailto:info@amitpaintings.com"><li className="mt-3 hover:text-pink-600">
                               <strong>Email</strong><br />
                               <p>info@amitpaintings.com</p>
                               </li>
                            </a>
                            <a href="tel:+919963322990"><li className="mt-3 hover:text-pink-600">
                               <strong>Mobile</strong><br />
                               <p>+91 9963322990</p>
                               </li>
                            </a>
                       </ul>
                    </div>
                    <div className="col-span-10 md:col-span-2 col-start-2">
                        <h5 className="text-ap text-lg mb-5 font-bold">Social</h5> 
                        <a href="blank">
                            <div className="flex bg-white rounded-lg shadow p-5 justify-between items-center">
                                <FontAwesomeIcon icon={faFacebook} size="2x" className="text-ap"/>
                                <p className="text-base text-as font-semibold">Amit Paintings</p>
                            </div>
                        </a>
                        <a href="blank">
                            <div className="flex bg-white rounded-lg shadow p-5 justify-between items-center mt-5">
                                <FontAwesomeIcon icon={faInstagram} size="2x" className="text-ap"/>
                                <p className="text-base text-as font-semibold">Amit Paintings</p>
                            </div>
                        </a>
                    </div>
                </div>
            </section>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.jsx